/* eslint-disable @typescript-eslint/no-var-requires */
import getLang from 'I18n/utils/getLang';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import { AppRoot, renderAppRoot } from 'quartz-core/internal/root-renderer';
import { initializeI18n } from 'quartz-i18n/initialize';
import { initializeTracking } from 'quartz-tracking/initialize';
import { quartzConfig } from 'quartz-config/evaluable';
import { invariant } from 'quartz/invariant';
import { initializeHistory } from 'quartz-routing/initialize';
import { mark } from './perf';
import { isPromiseLike } from './isPromiseLike';
import quartzCoreLang from 'i2l?sync&query=sporks!../../lang/en.lyaml';
import { Metrics } from './metrics';
import { getBasenameFromRouting } from '../util/getBasenameFromRouting';
import { jsx as _jsx } from "react/jsx-runtime";
export async function renderApp({
  prepareApp,
  AppComponent,
  getLocaleInfo
}, {
  rhumbConfig,
  lang,
  container,
  LayoutComponent,
  adapter
}) {
  /* invariant(quartzConfig.type === 'application') */
  ;
  const {
    htmlTitleLangKey,
    historyBasename: historyBasenameFromConfig,
    UNSAFE_EXPERIMENTAL_routing: routing
  } = quartzConfig;
  const historyBasename = /* quartzConfig.UNSAFE_EXPERIMENTAL_graniteOptions && quartzConfig.UNSAFE_EXPERIMENTAL_graniteOptions.type === 'host' */false ? '/' : historyBasenameFromConfig || getBasenameFromRouting(routing);
  if (!historyBasename) {
    throw new Error('historyBasename is required');
  }
  const {
    userId,
    localeInfoFallback
  } = await adapter.initialize(new URLSearchParams(window.location.search));
  const history = initializeHistory(historyBasename);
  const {
    isPublicI18n,
    registerFn
  } = adapter.getI18nConfig();
  const localeInfoResult = getLocaleInfo === null || getLocaleInfo === void 0 ? void 0 : getLocaleInfo();
  let localeInfo = isPromiseLike(localeInfoResult) ? await localeInfoResult : localeInfoResult;
  if (!isPublicI18n && !localeInfo) {
    localeInfo = localeInfoFallback;
  }
  const [result] = await Promise.all([prepareApp(), initializeI18n({
    langs: [lang, quartzCoreLang],
    createPublicProvider: isPublicI18n,
    localeInfo,
    registerFn,
    trackSetLocale: () => {
      Metrics.counter('i18n_setLocale_called').increment();
    }
  })]);
  const {
    email,
    hstc,
    hubId
  } = adapter.getTrackingProperties();
  initializeTracking({
    config: quartzConfig,
    trackerProperties: {
      lang: getLang(),
      email: email !== null && email !== void 0 ? email : null,
      hstc: hstc !== null && hstc !== void 0 ? hstc : null,
      hubId
    }
  });
  mark('quartz.prepareAppFinished');
  if (htmlTitleLangKey) {
    setDocumentTitle(htmlTitleLangKey);
  }
  let maybeRoot;
  if (result && 'redirect' in result) {
    window.location.href = result.redirect;
  } else {
    var _adapter$getCopilotOp, _result$onAfterRender;
    const copilotOptions = (_adapter$getCopilotOp = adapter.getCopilotOptions) === null || _adapter$getCopilotOp === void 0 ? void 0 : _adapter$getCopilotOp.call(adapter);
    maybeRoot = await renderAppRoot( /*#__PURE__*/_jsx(AppRoot, {
      history: history,
      rhumbConfig: rhumbConfig,
      rhumbTrackVisibility: quartzConfig.rhumbTrackVisibility,
      userId: userId,
      isGraniteHost: quartzConfig.UNSAFE_EXPERIMENTAL_graniteOptions && quartzConfig.UNSAFE_EXPERIMENTAL_graniteOptions.type === 'host',
      children: LayoutComponent ? /*#__PURE__*/_jsx(LayoutComponent, {
        children: /*#__PURE__*/_jsx(AppComponent, Object.assign({}, result === null || result === void 0 ? void 0 : result.props))
      }) : /*#__PURE__*/_jsx(AppComponent, Object.assign({}, result === null || result === void 0 ? void 0 : result.props))
    }), Object.assign({
      legacyRoot: adapter.shouldUseLegacyRoot(),
      strictMode: quartzConfig.reactStrictMode
    }, copilotOptions, {
      container
    }));
    result === null || result === void 0 || (_result$onAfterRender = result.onAfterRender) === null || _result$onAfterRender === void 0 || _result$onAfterRender.call(result);
    if ( /* 'plugins' in quartzConfig */false) {
      const {
        getAppExtensions
      } = require('./plugins/app-plugins');
      for (const plugin of getAppExtensions()) {
        plugin.hooks.onAfterRender();
      }
    }
    return maybeRoot;
  }
}